import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidatePortfolioOnForbidden } from "web_myplann/Api/Portfolio/invalidatePortfolioOnForbidden";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioCommoditiesEditRequestDTO,
	type PortfolioDetailResponseDTO,
	patchPortfolioCommoditiesIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPortfolioCommoditiesMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		PortfolioDetailResponseDTO,
		Error,
		Partial<ClientPortfolioCommoditiesEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPortfolioCommoditiesIdV2(requestContract, id),
		),
		onError: (error) => invalidatePortfolioOnForbidden(queryClient, error),
		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.setQueryData(PortfolioKeys.portfolioDetail(id), data);
		},
	});
};
